import styles from "./VisitorLabel.module.scss";

type VisitorLabelProps = {
  companyName: string;
  buildingName: string;
  visitorName: string;
  visitorPhone?: string;
  registeredAt: Date;
};

/**
 * Printable visitor label. Hidden on screen and only rendered during print,
 * so the page using it decides when to call `window.print()`.
 */
export function VisitorLabel({
  companyName,
  buildingName,
  visitorName,
  visitorPhone,
  registeredAt,
}: VisitorLabelProps) {
  const formattedDate = registeredAt.toLocaleDateString();
  const formattedTime = registeredAt.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div
      className={styles.label}
      aria-hidden="true"
      data-testid="label-content"
    >
      <div className={styles.labelLandscape}>
        <header className={styles.labelHeader}>
          <span className={styles.labelCompanyName}>{companyName}</span>
          <span className={styles.labelBuildingName}>{buildingName}</span>
          <div className={styles.labelAccentBar} />
        </header>

        <div className={styles.labelBody}>
          <p className={styles.labelVisitorName}>{visitorName}</p>
          <p className={styles.labelVisitorPhone}>{visitorPhone}</p>
        </div>

        <footer className={styles.labelFooter}>
          <span className={styles.labelDateTime}>
            {formattedDate}&nbsp;&nbsp;{formattedTime}
          </span>
        </footer>
      </div>
    </div>
  );
}
